module.exports = __webpack_public_path__ + "static/media/light-theme-total-exit.44467606.svg";